(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__collageGridLayoutBound) return;
    window.__collageGridLayoutBound = true;

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const isCollageBlock = (element) => {
      return element.matches('product-card, .image-block, a.image-block, deferred-media, .video-placeholder-wrapper');
    };

    const resetGridPlacement = (blocks) => {
      blocks.forEach((block) => {
        block.style.gridColumn = '';
        block.style.gridRow = '';
      });
    };

    const applyGridPlacement = (grid) => {
      const blocks = Array.from(grid.children).filter(isCollageBlock);
      const layout = grid.dataset.desktopLayout;

      resetGridPlacement(blocks);

      if (!desktopQuery.matches) return;

      if (blocks.length === 1) {
        blocks[0].style.gridColumn = '1 / span 3';
        blocks[0].style.gridRow = '1 / span 2';
        return;
      }

      if (blocks.length === 2) {
        if (layout === 'right') {
          blocks[0].style.gridColumn = '1';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '2 / span 2';
          blocks[1].style.gridRow = '1 / span 2';
        } else {
          blocks[0].style.gridColumn = '1 / span 2';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '3';
          blocks[1].style.gridRow = '1 / span 2';
        }
        return;
      }

      if (layout === 'right') {
        blocks[0].style.gridColumn = '1';
        blocks[0].style.gridRow = '1';
        blocks[1].style.gridColumn = '1';
        blocks[1].style.gridRow = '2';
        blocks[2].style.gridColumn = '2 / span 2';
        blocks[2].style.gridRow = '1 / span 2';
      } else {
        blocks[0].style.gridColumn = '1 / span 2';
        blocks[0].style.gridRow = '1 / span 2';
        blocks[1].style.gridColumn = '3';
        blocks[1].style.gridRow = '1';
        blocks[2].style.gridColumn = '3';
        blocks[2].style.gridRow = '2';
      }
    };

    const applyAllCollageGrids = (root = document) => {
      root.querySelectorAll('[data-testid="collage-grid"] .collage-grid').forEach((grid) => {
        applyGridPlacement(grid);

        if (!grid.__collageObserver) {
          grid.__collageObserver = new MutationObserver(() => applyGridPlacement(grid));
          grid.__collageObserver.observe(grid, { childList: true });
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => applyAllCollageGrids(), { once: true });
    document.addEventListener('shopify:section:load', (event) => applyAllCollageGrids(event.target));
    document.addEventListener('shopify:section:reorder', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:select', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:deselect', () => applyAllCollageGrids());
    desktopQuery.addEventListener('change', () => applyAllCollageGrids());

    applyAllCollageGrids();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgo-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hgo-collection-v2')) {
    customElements.define('hgo-collection-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.hgoReady) return;
        this.hgoReady = true;
        this.hgoAbort = new AbortController();
        const signal = this.hgoAbort.signal;
        const tabs = Array.from(this.querySelectorAll('[data-group-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-group-panel]'));
        const tablist = this.querySelector('[data-group-tabs]');
        if (tabs.length && tablist) {
          tablist.setAttribute('role', 'tablist');
          tablist.setAttribute('aria-label', 'Explore collections by');
          tabs.forEach(tab => tab.setAttribute('role', 'tab'));
          panels.forEach(panel => {
            panel.setAttribute('role', 'tabpanel');
            const tab = tabs.find(item => item.dataset.groupTab === panel.dataset.groupPanel);
            if (tab) panel.setAttribute('aria-labelledby', tab.id);
          });
          const activate = (group, moveFocus) => {
            tabs.forEach(tab => {
              const selected = tab.dataset.groupTab === group;
              tab.setAttribute('aria-selected', String(selected));
              tab.tabIndex = selected ? 0 : -1;
              if (selected && moveFocus) tab.focus();
            });
            panels.forEach(panel => { panel.hidden = panel.dataset.groupPanel !== group; });
          };
          activate(this.dataset.defaultGroup || 'product', false);
          tablist.hidden = false;
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activate(tab.dataset.groupTab, false), { signal });
            tab.addEventListener('keydown', event => {
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
              else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = tabs.length - 1;
              else return;
              event.preventDefault();
              activate(tabs[next].dataset.groupTab, true);
            }, { signal });
          });
        }
        this.querySelectorAll('[data-photo-toggle]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const active = button.getAttribute('aria-pressed') !== 'true';
            button.setAttribute('aria-pressed', String(active));
            button.closest('[data-product-card]')?.classList.toggle('is-alt', active);
          }, { signal });
        });
        this.querySelectorAll('[data-price-range]').forEach(range => {
          const min = range.querySelector('[data-price-min]');
          const max = range.querySelector('[data-price-max]');
          if (!min || !max) return;
          const validate = () => min.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? 'Enter a minimum price no greater than the maximum.' : '');
          min.addEventListener('input', validate, { signal });
          max.addEventListener('input', validate, { signal });
          validate();
        });
        // A real anchor scroll works with Horizon's nested .page-wrapper too.
        // No window-scroll listener, scroll hijacking or custom cart API is needed.
        const current = new URL(window.location.href);
        const view = current.searchParams.get('view');
        if (view && view === this.dataset.templateSuffix) {
          this.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.getAttribute('href'), current);
            if (url.origin === current.origin && /\/collections\/[^/]+\/?$/.test(url.pathname)) {
              url.searchParams.set('view', view);
              link.setAttribute('href', url.pathname + url.search + url.hash);
            }
          });
        }
        this.classList.add('is-enhanced');
      }
      disconnectedCallback() {
        this.hgoAbort?.abort();
        this.hgoReady = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
